import { cn } from '@/lib/utils'

/** Where a post goes, as an 18px monogram. No logo files: two letters on the
 *  platform's colour (Threads, X and TikTok on the foreground colour). */
const MARK: Record<string, { mono: string; name: string; className: string }> = {
  reddit: { mono: 'Rd', name: 'Reddit', className: 'bg-platform-reddit text-white' },
  reddit_browser: { mono: 'Rd', name: 'Reddit', className: 'bg-platform-reddit text-white' },
  bluesky: { mono: 'Bs', name: 'Bluesky', className: 'bg-platform-bluesky text-white' },
  threads: { mono: 'Th', name: 'Threads', className: 'bg-platform-mono text-platform-mono-foreground' },
  x: { mono: 'X', name: 'X', className: 'bg-platform-mono text-platform-mono-foreground' },
  tiktok: { mono: 'TT', name: 'TikTok', className: 'bg-platform-mono text-platform-mono-foreground' },
  ppomppu: { mono: '뽐', name: '뽐뿌', className: 'bg-platform-ppomppu text-white' },
  okky: { mono: 'OK', name: 'OKKY', className: 'bg-platform-okky text-white' },
  instagram: { mono: 'IG', name: 'Instagram', className: 'bg-platform-instagram text-white' },
}

export function platformName(platform: string): string {
  return MARK[platform]?.name ?? platform
}

export interface PlatformMarkProps {
  platform: string
  /** Also write the platform's name after the mark. */
  withName?: boolean
  className?: string
}

export function PlatformMark({ platform, withName, className }: PlatformMarkProps) {
  const m = MARK[platform] ?? {
    mono: platform.slice(0, 2),
    name: platform,
    className: 'bg-muted text-muted-foreground',
  }
  const mark = (
    <span
      role="img"
      aria-label={m.name}
      title={m.name}
      className={cn(
        'inline-flex h-[18px] min-w-[18px] shrink-0 select-none items-center justify-center rounded-[5px] px-[3px] text-[9.5px] font-bold leading-none tracking-normal',
        m.className,
        !withName && className,
      )}
    >
      {m.mono}
    </span>
  )
  if (!withName) return mark
  return (
    <span className={cn('inline-flex items-center gap-1.5 text-table', className)}>
      {mark}
      <span>{m.name}</span>
    </span>
  )
}
